module.exports = __webpack_public_path__ + "img/HU22574361.7aa59492.png";